/**
 * La búsqueda en Google Maps de una dirección escrita a mano.
 *
 * No hay coordenadas y no las va a haber por ahora: la dirección es el texto
 * libre que el dueño tipeó en su panel. Ésta es la URL oficial de Google para
 * buscar, no pide API key, y en el celular abre la app de mapas en vez del
 * navegador.
 *
 * Si lo que escribió no es una dirección —"al lado de la plaza"— el mapa
 * muestra una búsqueda que no encuentra nada. Es preferible a no ofrecer el
 * botón, y por eso el mismo link está en Configuración: el dueño lo prueba una
 * vez y se da cuenta antes que un cliente.
 *
 * Lo usan la cabecera de la página pública y el campo del panel. Una sola vez,
 * para que el día que cambie —o que se le agregue el nombre del negocio a la
 * búsqueda— cambie en los dos lugares.
 */
export const linkDeMapa = (direccion) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(String(direccion ?? '').trim())}`;

/**
 * La misma búsqueda, pero para meter adentro de un <iframe>.
 *
 * Google redirige esta URL a /maps/embed?pb=… y dibuja el mapa con el punto
 * marcado, sin API key. Fuera de un iframe no funciona: contesta "The Google
 * Maps Embed API must be used in an iframe", así que no sirve para abrir en
 * una pestaña. Para eso está linkDeMapa.
 *
 * ─── Lo que hay que saber de esta URL ──────────────────────────────────────
 *
 * No está documentada. Lo que Google documenta es la Maps Embed API, que pide
 * una API key, y el link que arma el botón "Compartir → Insertar un mapa", que
 * se genera a mano lugar por lugar y acá no sirve porque la dirección la
 * escribe cada negocio. `output=embed` es un atajo viejo que anda hace años,
 * pero puede dejar de andar sin aviso.
 *
 * Por eso el mapa es un agregado y nunca la única forma de saber dónde queda:
 * la dirección en texto y el botón "Cómo llegar" viven en la cabecera y no
 * dependen de esto. Si un día el iframe muestra un error, la página sigue
 * contestando la pregunta.
 */
export const mapaEmbebido = (direccion) =>
  `https://www.google.com/maps?q=${encodeURIComponent(String(direccion ?? '').trim())}&output=embed`;
